// helpers.ts — Pure utility functions for L204 form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/**
 * Count lines for memo content at 78-char width.
 * Approximation: split by newlines, then count line wraps at 78 chars per line.
 */
export const countMemoLines = (text: string): number => {
  if (!text) return 0;
  const lines = text.split('\n');
  let total = 0;
  for (const line of lines) {
    if (line.length === 0) {
      total += 1;
    } else {
      total += Math.ceil(line.length / 78);
    }
  }
  return total;
};

/**
 * Get the line limit for a page.
 * Page 1 (first page) = 45 lines max; other pages = 55 lines max.
 */
export const getLineLimit = (pageNo: number): number => {
  return pageNo === 1 ? 45 : 55;
};

/**
 * Get approval status label from parent doc FL040_80.
 */
export const getApprovalLabel = (fl040_80: string | undefined): string | null => {
  if (!fl040_80) return null;
  const status = fl040_80.trim();
  if (status === 'V' || status === 'S') return '管理代表巳核准!';
  if (status === 'Y') return '總經理巳核准!';
  return null;
};

/**
 * Check if the record is locked for edit/delete (parent doc is approved).
 */
export const isApprovalLocked = (fl040_80: string | undefined): boolean => {
  if (!fl040_80) return false;
  const status = fl040_80.trim();
  return status === 'V' || status === 'S' || status === 'Y';
};

/** Fields that are always readonly (even in edit mode) */
const ALWAYS_READONLY = new Set([
  'fl140_01', // 文件編號
  'fl140_02', // 頁次
]);

/** Determine if a field should be disabled */
export const isFieldDisabledFn = (key: string, isEditing: boolean, mode: string): boolean => {
  if (!isEditing) return true;
  if (ALWAYS_READONLY.has(key)) return true;
  // In edit mode, docNo and pageNo are locked
  if (mode === 'edit' && (key === 'fl140_01' || key === 'fl140_02')) return true;
  return false;
};
